import { cva } from 'class-variance-authority';
import { fontBase } from '@/lib/styleUtils';

/*
 * `dot` keeps its solid `bg-*` fill and layers the dot-gradient utility on
 * top, feeding it that state's theme colour via --dot-gradient-color. The gradient
 * stops are derived from that colour (see globals.css), so a tenant re-tinting
 * colorAccent / colorBrandError / colorBrandWarn re-tints the gradient with it —
 * nothing here is a fixed green or red. The solid fill stays as the fallback for
 * browsers without color-mix().
 */
export const statusColorMap = {
  positive: {
    text: 'tw:text-accent-dark',
    bg: 'tw:bg-accent/20',
    dot: 'tw:bg-accent tw:[--dot-gradient-color:var(--tw-color-accent)] tw:dot-gradient',
  },
  negative: {
    text: 'tw:text-error',
    bg: 'tw:bg-error/20',
    dot: 'tw:bg-error tw:[--dot-gradient-color:var(--tw-color-error)] tw:dot-gradient',
  },
  neutral: {
    text: 'tw:text-warn',
    bg: 'tw:bg-warn/20',
    dot: 'tw:bg-warn tw:[--dot-gradient-color:var(--tw-color-warn)] tw:dot-gradient',
  },
} as const;

export const statusVariants = cva(`${fontBase} tw:inline-flex tw:items-center tw:h-fit`, {
  variants: {
    variant: {
      primary: 'tw:px-small tw:py-nano tw:rounded-full',
      secondary: '',
    },
    type: {
      text: 'tw:gap-micro',
      icon: 'tw:bg-transparent tw:p-0',
    },
  },
  defaultVariants: {
    variant: 'primary',
    type: 'text',
  },
});

export const dotVariants = cva('tw:rounded-full tw:flex-shrink-0', {
  variants: {
    type: {
      text: 'tw:w-[0.5rem] tw:h-[0.5rem]',
      icon: 'tw:w-[1rem] tw:h-[1rem]',
    },
  },
  defaultVariants: {
    type: 'text',
  },
});

export const textClasses = 'tw:text-14 tw:font-regular tw:leading-1';
